import { createSelector } from 'reselect';

export const productionLeadTimeSelector = createSelector(
  (state) => state.deliveryInfo,
  (deliveryInfo) => deliveryInfo.productionLeadTime,
);
